import { useApi } from 'Shared/services/Api';
import { TimelineApiResponse } from './types';

export function useTimelineData(policyId: string | undefined) {
  const [{ data, loading, error }] = useApi<TimelineApiResponse>(
    `/policies/${policyId}/timeline`,
    false
  );

  return {
    timeline: data?.terms ?? [],
    // DLC-138 feature flag: false (and undefined while loading) means
    // the tab + content stay hidden. Default false so we fail closed
    // when the response is malformed.
    showTimeline: data?.showTimeline ?? false,
    loading,
    error,
  };
}
